module.exports = __webpack_public_path__ + "static/media/Image03.fdda6ec7.png";